export const APPLICATION_CSC_HEADER = {
        DETAILS: 'Details',
        VERIFY_DOCUMENTS: 'Verify documents',
        SERVICE_CENTERS:' Service centers',
        PLACE_ORDER:' Place order'
    }
    export const APPLICATION_DETAILS = {
           LOGIN_TEXT_HEADING    : 'to apply for this service/job.',
           CLICK_HERE_TEXT_HEADING      :'to check your eligibility,verify documents to apply for this service/job.',
           ACCORDION_IMP_DATES:'Important Dates',
           ACCORDION_IMP_DATES_START_DATE: 'Start Date for Apply Online Form:',
           ACCORDION_IMP_DATES_END_DATE: 'Last Date for Apply Online Form:',
           ACCORDION_IMP_DATES_EXAM: 'Exam Date:',
           ACCORDION_IMP_DATES_ADMIT_CARD: 'Admit Card Available:',
           ACCORDION_AGE: 'Age',
           ACCORDION_AGE_MINIMUM: 'Minimum age:',
           ACCORDION_AGE_MAXIMUM: 'Maximum age:',
           ACCORDION_AGE_RELAXATION: 'Age Relaxation As Per Rules.(Please refer official notification for more info)',
           ACCORDION_FEE: 'Application fee',
           ACCORDION_FEE_GENERAL: 'General/Un-reserved(UR):',
           ACCORDION_FEE_EWS: 'EWS:',
           ACCORDION_FEE_OBC: 'OBC:',
           ACCORDION_FEE_SC_ST: 'SC/ST:',
           ACCORDION_SELECTION_CRITERIA: 'Selection Criteria',
           ACCORDION_SELECTION_CRITERIA_DESC: 'There will be total three phase(s)',
           ACCORDION_OFFICIAL_LINKS: 'Official Links',
           ACCORDION_OFFICIAL_LINKS_NOTIFICATION: 'Notification:',
           ACCORDION_OFFICIAL_LINKS_WEBSITE: 'Website:'

    }
    export const COMMON = {
            LOGIN: 'Login',
            CLICK_HERE: 'Click here',
    
    removeDocument: 'Are you sure you want to remove document?',
    cancelApplication: 'Are you sure you want to cancel application?',
    rightBtnTitle: 'Yes',
    leftBtnTitle: 'No',
    copyLinkPrefix: 'Link for',
    copyLinkSuffix: 'application has been copied to clipboard.',
    ERROR_ACCOUNT_DISABLED : "Account disabled due to many failed login attempts.Either reset your password or you can try again later.",
    ERROR_NO_INTERNET_CONNECTION: "Please check your internet connection.",
    DIALOG_SHARE_TITLE:' Enter Email ID or Mobile Number to receive the service centers',
    DIALOG_SHARE_SUB_TITLE:' The service centers will be shared on your device',
    SERVICE_CENTER_SHARE_MOB_SUCCESS: 'Service centers link has been shared to your mobile device.',
    SERVICE_CENTER_SHARE_EMAIL_SUCCESS: 'Service centers link has been shared to email address.',
    FILTER_APP_HEADING: 'Service category',
    FILTER_APP_STATE_HEADING:'State',
    FILTER_APP_STATE_HEADING_DESC: 'Find Your Next Career in State Government to Serve in Local Bodies',
    FILTER_APP_QUALIFICATION_HEADING:'Qualification',
    FILTER_APP_QUALIFICATION_HEADING_DESC: 'Explore Jobs Tailored to Your Professional Qualification',
    FILTER_APP_POPULAR_CATEGORIES_HEADING:'Popular categories',
    FILTER_APP_POPULAR_CATEGORIES_HEADING_DESC: 'Explore Popular Jobs Categories in the India Government',
    FILTER_APP_COMMON_SERVICE_HEADING:'Common Services',
    FILTER_APP_COMMON_SERVICE_HEADING_DESC: 'Apply for Services like Aadhar, PAN Card etc. in few Clicks',
    CHOOSE_US_HEADING: 'Why choose us?',
    CHOOSE_US_NO_QUEUE: 'No Queue',
    CHOOSE_US_NO_QUEUE_DESCRIPTION: 'No waiting line or lineup for the service or online application, you are a request away for online service.',
    CHOOSE_US_LOW_CHARGES: 'Low Charges',
    CHOOSE_US_LOW_CHARGES_DESCRIPTION: 'Cost-effective advantages to using the online platform compared to traditional methods.',
    CHOOSE_US_EASY_APPLY: 'Easy Apply',
    CHOOSE_US_EASY_APPLY_DESCRIPTION: 'Apply for online jobs or services with just a few clicks and fill out the required forms.',
    BEST_PLACE_INFO_HEADING:'Over 1k+',
    BEST_PLACE_INFO_DESC: 'customers trust us & have apply their service on online application portal',
    BEST_PLACE_SERVICE_CENTER_HEADING: '50+ CSC',
    BEST_PLACE_SERVICE_CENTER_DESC: 'partnered with us so that you can compare easily & transparently',
    BEST_PLACE_LOWEST_PRICE_HEADING: 'Great price',
    BEST_PLACE_LOWEST_PRICE_DESC: 'for all kinds of online services like job forms, aadhar, pan etc',
    BEST_PLACE_FAST_SERVICE_HEADING: 'Easy',
    BEST_PLACE_FAST_SERVICE_DESC: 'to explore, select, and apply to get all services at one place in few clicks',
    BEST_PLACE_LIVE_STATUS_HEADING: 'Live status',
    BEST_PLACE_LIVE_STATUS_DESC: 'of applied services and you can track applicaiton status',
    DOCUMENT_UPLOADED_SUCCESS_MESSAGE: 'Document has been uploaded successfully'

    }

    export const ABOUT_LABELS = {
        ABOUT_HEADING: 'About Us',
        ABOUT_DESCRIPTION: 'We are committed to providing the best online application services for government jobs and services across India.',
        ABOUT_MISSION_HEADING: 'Our Mission',
        ABOUT_MISSION_DESC: 'To simplify the application process and make government services accessible to everyone, regardless of location or technical expertise.',
        ABOUT_VISION_HEADING: 'Our Vision',
        ABOUT_VISION_DESC: 'To be the most trusted platform for online government applications — fast, transparent, and reliable for every citizen.',
        ABOUT_JOB_APPLICATIONS_HEADING: 'Job Applications Made Simple',
        ABOUT_JOB_APPLICATIONS_DESC: 'Apply for government jobs across multiple states and qualifications from a single dashboard. We track deadlines, surface notifications, and walk you through document verification.',
        ABOUT_OTHER_SERVICES_HEADING: 'Other Online Services',
        ABOUT_OTHER_SERVICES_DESC: 'Beyond job applications, we help you complete everyday government services online — without queues, without hidden charges.',
        ABOUT_SERVICE_AADHAR: 'Aadhar enrolment & updates',
        ABOUT_SERVICE_PAN: 'PAN card application',
        ABOUT_SERVICE_ELECTRICITY: 'Electricity bill payments',
        ABOUT_OTHER_SERVICES_NOTE: 'More services are being added every month based on what our users ask for.',
        ABOUT_CONTACT_HEADING: 'Got a question? Talk to us.',
        ABOUT_CONTACT_DESC: 'Our team is available to help with applications, document verification, and any service-related queries.',
    }

    export const LOGIN_LABELS = {
        EMAIL_LABEL: 'Email address',
        PASSWORD_LABEL: 'Password',
        FULLNAME_LABEL: 'Full name',
        LOGIN_BUTTON: 'Login',
        LOGIN_LOADING: 'Logging in',
        SIGNUP_BUTTON: 'Sign up',
        SIGNUP_LOADING: 'Signing up',
        RESET_PASSWORD_BUTTON: 'Reset Password',
        RESET_PASSWORD_LOADING: 'Sending',
        RESET_PASSWORD_HEADING: 'Enter your email address to reset password',
        RESET_PASSWORD_SUCCESS: 'If an account exists for {email}, you will get an email with instructions on resetting your password. If it doesn\'t arrive, be sure to check your spam folder.',
        RESET_PASSWORD_LINK: 'Reset Password?',
        CANCEL: 'Cancel',
        BACK_TO_LOGIN: 'Back to Login',
        DONT_HAVE_ACCOUNT: "Don't have an account?",
        ALREADY_HAVE_ACCOUNT: 'Already have an account?',
        SIGNUP_LINK: 'Sign up',
        LOGIN_LINK: 'Login',
        OR: 'OR',
        LOGIN_WITH_GOOGLE: 'Login with Google',
    };

    export const USER_PROFILE_MENU_LABELS = {
        ACCOUNT: 'Account',
        PROFILE: 'Profile',
        DOCUMENTS: 'Documents',
        LOGOUT: 'Logout',
        LOGIN_SIGNUP: 'Login/Signup',
    };

    export const CUSTOMER_REVIEW_LABELS = {
        HEADING: 'Some words from our happy customers!',
        REVIEW_1: 'I recently used the online application form on online applications, and I must say, it was incredibly convenient and straightforward. The entire process from start to finish was smooth and user-friendly.',
        REVIEW_2: 'Overall, my experience with online application form was excellent. It saved me time and effort, and I would definitely recommend it to anyone looking for a hassle-free way to submit applications online.',
        REVIEW_3: 'What impressed me the most was the responsiveness of the platform. It worked flawlessly on both desktop and mobile devices, which made it super convenient for me to fill out the form on the go.',
        CUSTOMER_1: 'Rahul Jangra',
        CUSTOMER_2: 'Amit Verma',
        CUSTOMER_3: 'Ankush Saharan',
        DATE_1: 'Mar 23, 2024',
        DATE_2: 'Jan 10, 2024',
        DATE_3: 'Feb 11, 2024',
    };

    export const DOCUMENT_VERIFICATION_LABELS = {
        CLICK_HERE: 'Click here',
        TO_CHECK_NEARBY: 'to check your nearby service centers.',
    };

    export const FILTER_APPLICATIONS_LABELS = {
        SELECT_STATE_DIALOG_HEADER: 'Select your state',
    };

    export const UPLOAD_DOC_LABELS = {
        SELECT_CATEGORY: 'Select Category',
        INVALID_FILE_TYPE: 'Invalid file type. Please upload DOC, PDF or image type.',
        PLEASE_SELECT_CATEGORY: 'Please select category.',
        UPLOADING: 'Uploading...',
        UPLOAD: 'Upload',
        UPLOADED_SUCCESS: 'Document file has been uploaded successfully.',
    };

    export const APPLICATION_CSC_CARD_HEADER_LABELS = {
      CONSTABLE: 'Constable',
    };

    export const CHOOSE_US_LABELS = {
      CHOOSE_US_HEADING: 'Why choose us?',
      CHOOSE_US_NO_QUEUE: 'No Queue',
      CHOOSE_US_NO_QUEUE_DESCRIPTION: 'No waiting line or lineup for the service or online application, you are a request away for online service.',
      CHOOSE_US_LOW_CHARGES: 'Low Charges',
      CHOOSE_US_LOW_CHARGES_DESCRIPTION: 'Cost-effective advantages to using the online platform compared to traditional methods.',
      CHOOSE_US_EASY_APPLY: 'Easy Apply',
      CHOOSE_US_EASY_APPLY_DESCRIPTION: 'Apply for online jobs or services with just a few clicks and fill out the required forms.'
    };

    export const USER_PROFILE_MOBILE_DRAWER_LABELS = {
      ACCOUNT: 'Account',
      PROFILE: 'Profile',
      DOCUMENTS: 'Documents',
      LOGOUT: 'Logout',
    };

    export const USER_BASIC_PROFILE_LABELS = {
      PERSONAL: 'Personal',
      CONTACT: 'Contact',
      EDUCATION: 'Education',
      IDENTITY: 'Identity',
      BACK: 'Back',
      NEXT: 'Next',
      RESET: 'Reset',
    };

    export const APP_FOOTER_LABELS = {
      ONLINE_APPLICATIONS: 'Online Applications',
      ADDRESS_LINE_1: '484, Siswala Farm House',
      ADDRESS_LINE_2: 'Hisar, 125004, Haryana',
      ADDRESS_LINE_3: 'HISAR – 125001',
      PRODUCTS: 'Products',
      GOVT_EXAM_FORMS: 'Govt. Exam Forms',
      ONLINE_SERVICES: 'Online Services',
      PAN_AADHAR: 'PAN Card / Aadhar Card',
      QUICK_LINKS: 'Quick Links',
      APPLICATION_STATUS: 'Application Status',
      SERVICES: 'Services',
      CLICK_AND_APPLY: 'Click and Apply',
      FOOTER_TAGLINE: 'Your gateway to all government services — fast, simple, reliable.',
      FOOTER_GET_IN_TOUCH: 'Get in Touch',
      FOOTER_CONTACT_DESC: 'Have a question or need help with an application? Our team is here for you.',
      FOOTER_CONTACT_EMAIL: 'onlineapplicationshelpline@gmail.com',
      FOOTER_CONTACT_CTA: 'Contact Us',
      FOOTER_COPYRIGHT: '© 2024 Online Applications. All rights reserved.',
      FOOTER_PRIVACY: 'Privacy Policy',
      FOOTER_TERMS: 'Terms of Service',
      FOOTER_ABOUT: 'About Us',
      FOOTER_CONTACT_LINK: 'Contact',
    };

    export const USER_APPLICATIONS_LABELS = {
      SAVE: 'Save',
      // Add more as you refactor the component
    };

    export const PERSONAL_DETAILS_LABELS = {
      FULL_NAME: 'Full name',
      GENDER: 'Gender',
      MALE: 'Male',
      FEMALE: 'Female',
      OTHER: 'Other',
      DOB: 'Date of birth',
      MOBILE: 'Mobile number',
      SAVE: 'Save',
    };

    export const CONTACT_DETAILS_LABELS = {
      ALTERNATE_MOBILE: 'Alternate Mobile',
      ALTERNATE_EMAIL: 'Alternate email',
      ADDRESS: 'Address',
      DISTRICT_CITY: 'District/City',
      PINCODE: 'Pincode',
      STATE: 'State',
      COUNTRY: 'Country',
      SAVE: 'Save',
    };

    export const EDUCATION_DETAILS_LABELS = {
      TENTH: '10th',
      TWELFTH: '12th',
      DIPLOMA: 'Diploma',
      GRADUATION: 'Graduation',
      POST_GRADUATION: 'Post graduation',
      PHD: 'Phd',
      YEAR_OF_PASSING: 'Year of passing',
      COURSE_NAME: 'Course name',
      BRANCH: 'Diploma branch',
      CGPA: 'CGPA',
      PERCENTAGE: 'Percentage',
      SAVE: 'Save',
      PLACEHOLDER_CGPA: 'Enter your CGPA',
      PLACEHOLDER_PERCENTAGE: 'Enter your percentage',
      PLACEHOLDER_COURSE: 'Art, Non-medical, Medical, Commerce etc...',
      PLACEHOLDER_DIPLOMA: 'ITI, Polytechnic etc...',
      PLACEHOLDER_DIPLOMA_BRANCH: 'Electronics, electrical, fitter, civil, mechanical etc...',
      PLACEHOLDER_GRADUATION: 'B.A, B.Sc, B.com, BCA, B.tech etc...',
      PLACEHOLDER_POST_GRADUATION: 'M.A, M.Sc, M.com, MCA, M.tech etc...',
      PLACEHOLDER_PHD: 'Phd in specialization',
    };

    export const IDENTITY_DETAILS_LABELS = {
      AADHAR: 'AADHAR',
      PAN: 'PAN',
      SAVE: 'Save',
      PLACEHOLDER_AADHAR: 'XXXX XXXX XXXX',
    };

    export const TOASTR_MESSAGE_LABELS = {
      ERROR: 'Error',
    };

    export const BEST_PLACE_LABELS = {
      MAIN_HEADING: "What makes Online applications one of India's favourite place to apply service in few minutes?",
    };

    export const PRICE_DETAILS_LABELS = {
      PRICE_DETAILS: 'Price Details',
      PRICE_ITEM: 'Price (1 item)',
      DELIVERY_CHARGES: 'Delivery Charges',
      TOTAL_AMOUNT: 'Total Amount',
    };

    export const STATE_LIST_LABELS = {
      HARYANA: 'Haryana',
      RAJASTHAN: 'Rajasthan',
      CHANDIGARH: 'Chandigarh',
      DELHI: 'Delhi',
      UTTAR_PRADESH: 'Uttar Pradesh',
      HIMACHAL_PRADESH: 'Himachal Pradesh',
      PUNJAB: 'Punjab',
    };

    export const APP_MOBILE_DRAWER_LABELS = {
      DARK: 'Dark',
      LIGHT: 'Light',
    };

    export const CONTACT_LABELS = {
      FEWER_CALLS: 'Fewer Calls',
      BETTER_ASSISTANCE: 'Better Assistance',
      MAIN_HEADING: 'Fewer Calls\nBetter Assistance',
      SUB_HEADING: "We understand the importance of your time and don't want to leave you waiting for a phone call. That's why we advocate for the use of live chat and other online communication methods, which offer more efficient solutions to address your needs",
      ASSIST_HEADING: 'How Can We Assist You?',
      ASSIST_SUB_HEADING: 'We are here for you 24/7. Our Customer Success Team is called that way for a reason. Email us - onlineapplicationshelpline@gmail.com',
      OFFICE_LOCATIONS: 'Our office Locations',
      OFFICE_ADDRESS: 'Hisar, Haryana, India',
      FOLLOW_US: 'Follow us',
    };

    export const USER_DOCUMENTS_LABELS = {
      ADD_DOCUMENT: 'Add Document',
      DOCUMENT_NAME: 'Document Name',
      DOCUMENT_CATEGORY: 'Document Category',
      UPLOADED_ON: 'Uploaded On',
      STATUS: 'Status',
      PROGRESS: 'Progress',
      ACTIONS: 'Actions',
      NO_FILE_SELECTED: 'You have no file selected',
      DUPLICATE_FILE: 'Duplicate selected file',
      COMPLETE: 'Complete',
      FAILED: 'Failed',
      SELECT_CATEGORY_UPLOAD_DOCUMENT: 'Select Category & Upload Document',
      CANCEL: 'Cancel',
    };

    export const PAYMENT_OPTIONS_LABELS = {
      PAYMENT_OPTIONS: 'Payment Options',
      CASH_ON_DELIVERY: 'Cash on Delivery',
      CREDIT_CARD: 'Credit Card',
      DEBIT_CARD: 'Debit Card',
      NET_BANKING: 'Net Banking',
    };

    export const FILE_DELETE_DIALOG_LABELS = {
      DELETE_CONFIRM: 'Are you sure you want to delete {fileName}?',
      CANCEL: 'Cancel',
      DELETE: 'Delete',
    };

    export const HOME_PAGE_LABELS = {
      CONFUSED_HEADING: 'Confused with multiple applications?',
      MAIN_HEADING: 'All online applications,\nright here.',
      SUBTITLE: 'Find and apply to all the latest online applications in one place.',
      EXPLORE_LATEST: 'Explore Applications',
      WHAT_APPLY_TODAY: 'What would you like to apply today?',
      CHECK_STATUS: 'Check Application Status',
      HERO_NO_QUEUE: 'No queues. No travel. Apply for government services directly from home — through your nearest CSC center or online.',
      HERO_SERVICES_TITLE: 'Available Services',
      HERO_LIVE_BADGE: 'Live',
      HERO_APPLY_ANYWHERE: 'Apply from anywhere, anytime',
      HERO_STAT_APPLICATIONS: 'Applications Served',
      HERO_STAT_CSC: 'CSC Partners',
      HERO_STAT_STATES: 'States Covered',
      HERO_STAT_FREE: 'Free to Apply',
      HERO_AADHAR: 'Aadhar Services',
      HERO_PAN: 'PAN Card',
      HERO_EXAM: 'Exam Forms',
      HERO_STATUS_OPEN: 'Open',
      HERO_STATUS_NEARBY: 'Nearby',
    };

    export const NAVBAR_LABELS = {
      HOME: 'Home',
      SERVICES: 'Services',
      ABOUT_US: 'About Us',
      CONTACT_US: 'Contact Us',
      LOGIN: 'Login',
      SIGNUP: 'Sign Up',
      PROFILE: 'Profile',
      LOGOUT: 'Logout',
      APPLICATIONS: 'Applications',
      ONLINE_APPLICATIONS: 'Online Applications',
      DARK_MODE: 'Dark Mode',
      LIGHT_MODE: 'Light Mode',
    };

    export const CSC_OWNER_LABELS = {
      CSC_OWNER_PORTAL: 'CSC Owner Portal',
      CSC_OWNER: 'CSC Owner',
      CUSTOMER: 'Customer',
      SIGN_IN_AS: 'Sign in as',
      CHOOSE_ACCOUNT_TYPE: 'Choose your account type to continue',
      CUSTOMER_CARD_TITLE: 'Customer',
      CUSTOMER_CARD_DESC: 'Apply for government services and track your applications',
      CSC_OWNER_CARD_TITLE: 'CSC Owner',
      CSC_OWNER_CARD_DESC: 'Register and manage your Common Service Center',
      CSC_REGISTER_TAB: 'Register',
      CSC_LOGIN_TAB: 'Login',
      CSC_REGISTER_HEADING: 'Register your CSC',
      CSC_REGISTER_SUBTITLE: 'Fill in your Common Service Center details to get started',
      CSC_LOGIN_HEADING: 'Welcome back',
      CSC_LOGIN_SUBTITLE: 'Sign in to your CSC owner portal',
      OWNER_NAME: 'Owner Name',
      CSC_CENTER_NAME: 'CSC Center Name',
      MOBILE_NO: 'Mobile Number',
      CSC_ADDRESS: 'CSC Address',
      VILLAGE_TOWN: 'Village / Town',
      PINCODE: 'Pincode',
      CITY: 'City',
      STATE: 'State',
      MAP_LOCATION: 'Map Location / Google Maps Link',
      CSC_REGISTER_BTN: 'Register CSC',
      CSC_LOGIN_BTN: 'Sign In',
      CSC_ALREADY_ACCOUNT: 'Already have an account?',
      CSC_NO_ACCOUNT: "Don't have an account?",
      CSC_BACK: '← Change account type',
      CSC_DASHBOARD: 'Dashboard',
      CSC_MY_PROFILE: 'My Profile',
      CSC_ADD_SERVICE: 'Add Service',
      CSC_MY_SERVICES: 'My Services',
      CSC_REQUESTS: 'Service Requests',
      CSC_MY_CATEGORIES: 'My Categories',
      CSC_LOGOUT: 'Logout',
      CSC_WELCOME: 'Welcome back',
      CSC_TOTAL_SERVICES: 'Total Services',
      CSC_TOTAL_REQUESTS: 'Total Requests',
      CSC_PENDING: 'Pending',
      CSC_COMPLETED: 'Completed',
      CSC_PROFILE_HEADING: 'CSC Profile',
      CSC_PROFILE_SUBTITLE: 'Update your CSC center details',
      CSC_SAVE_CHANGES: 'Save Changes',
      CSC_ADD_SERVICE_HEADING: 'Add New Service',
      CSC_ADD_SERVICE_SUBTITLE: 'Create a new service offering for your customers',
      CSC_REGISTER_SERVICE_HEADING: 'Register New Service',
      CSC_REGISTER_SERVICE_SUBTITLE: 'Fill in the details to register a new service for your customers',
      CSC_REQUESTS_HEADING: 'Service Requests',
      CSC_REQUESTS_SUBTITLE: 'Applications submitted by users for your CSC center',
      CSC_COMING_SOON: 'Coming Soon',
      CSC_ADD_SERVICE_EMPTY: 'Service creation form is under development',
      CSC_REQUESTS_EMPTY: 'No applications have been submitted for your center yet.',
      CSC_REQUESTS_ALL: 'All',
      CSC_REQUESTS_APPLICANT: 'Applicant',
      CSC_REQUESTS_DOCS: 'Documents',
      CSC_REQUESTS_SUBMITTED: 'Submitted',
      CSC_REQUESTS_LAST_DATE: 'Last date',
      CSC_REQUESTS_UPDATE_STATUS: 'Update status',
      CSC_REQUESTS_SEARCH: 'Search by applicant or service…',
      CSC_REQUESTS_NO_MATCH: 'No requests match your filters.',
    };

    const EN_LABELS = {
        ...APPLICATION_CSC_HEADER,
        ...APPLICATION_DETAILS,
        ...COMMON,
        ...ABOUT_LABELS,
        ...LOGIN_LABELS,
        ...USER_PROFILE_MENU_LABELS,
        ...CUSTOMER_REVIEW_LABELS,
        ...DOCUMENT_VERIFICATION_LABELS,
        ...FILTER_APPLICATIONS_LABELS,
        ...UPLOAD_DOC_LABELS,
        ...APPLICATION_CSC_CARD_HEADER_LABELS,
        ...CHOOSE_US_LABELS,
        ...USER_PROFILE_MOBILE_DRAWER_LABELS,
        ...USER_BASIC_PROFILE_LABELS,
        ...APP_FOOTER_LABELS,
        ...USER_APPLICATIONS_LABELS,
        ...PERSONAL_DETAILS_LABELS,
        ...CONTACT_DETAILS_LABELS,
        ...EDUCATION_DETAILS_LABELS,
        ...IDENTITY_DETAILS_LABELS,
        ...TOASTR_MESSAGE_LABELS,
        ...BEST_PLACE_LABELS,
        ...PRICE_DETAILS_LABELS,
        ...STATE_LIST_LABELS,
        ...APP_MOBILE_DRAWER_LABELS,
        ...CONTACT_LABELS,
        ...USER_DOCUMENTS_LABELS,
        ...PAYMENT_OPTIONS_LABELS,
        ...FILE_DELETE_DIALOG_LABELS,
        ...HOME_PAGE_LABELS,
        ...NAVBAR_LABELS,
        ...CSC_OWNER_LABELS,
    };

    export default EN_LABELS;